import * as React from 'react';
import {connect} from 'react-redux';
import * as FDC3 from 'openfin-fdc3';

import {RootState} from '../../../store/State';
import {ChannelData} from '../../../store/partials/ChannelManager';

import * as Styles from './ChannelSelectorHeader.module.scss';

interface Props {
    systemChannels: ChannelData<FDC3.SystemChannel>[];
}

const ChannelSelectorHeaderComponent: React.FC<Props> = React.memo((props) => {
    const {systemChannels} = props;

    return (
        <div className={Styles['channel-selector-header']}>
            <div className={Styles['option']}> Default </div>
            {systemChannels.map((channel, i) => <div className={Styles['option']} key={i}>
                {channel.channel.visualIdentity.name}
            </div>)}
        </div>
    );
});

const mapState = (state: RootState) => ({
    systemChannels: Object.values(state.channelManager.channels).filter((x) => x.channel.id !== FDC3.defaultChannel.id) as ChannelData<FDC3.SystemChannel>[]
});

export const ChannelSelectorHeader = connect(mapState)(ChannelSelectorHeaderComponent);
